<template>
	<div v-if="this.message" class="alert alert-dismissible" :class="'alert-' + this.type">
		<span>{{this.message}}</span>
		<button type="button" class="close" v-on:click="close()">
			<span>&times;</span>
		</button>
	</div>
</template>

<script lang="js">
export default {
	props: ['type'],
	data() {
		return {
			message: null,
			timeout: null,
		};
	},
	methods: {
		set: function(message, time) {
			this.clearTimeout()
			this.message = message
			if (time === undefined || !this.message) {
				return
			}
			this.timeout = setTimeout(() => {
				this.message = null
			}, time)
		},
		clearTimeout: function() {
			if (this.timeout) {
				clearTimeout(this.timeout)
			}
		},
		close: function() {
			this.message = null
			this.clearTimeout()
		},
		isShown: function() {
			return this.message != null
		},
	},
	beforeDestroy: function() {
		this.clearTimeout()
	},
};
</script>

<style scoped>
.alert {
	border-radius: 5px;
	border: 1px solid red;
	margin-bottom: 1em;
	padding: 0.5em 0.7em;
}
.alert span {
	font-size: 14px;
}
.alert-danger, .alert-danger button {
	color: #721c24;
	background: #f8d7da;
	border-color: #f5c6cb;
}
.alert button {
	float: right;
	background: none;
	border: 0;
	margin: 0;
	width: auto;
	padding: 0 2px;
}
</style>
